import React from 'react';
import { useLocation } from 'react-router-dom';
import { ChevronRightIcon } from '@heroicons/react/24/outline';
import NAV_CONFIG from './Navconfig';

function flatten(items) {
  return items.reduce((acc, item) => {
    if (item.path) {
      acc[item.path] = item.title;
    }
    if (item.children) {
      Object.assign(acc, flatten(item.children));
    }
    return acc;
  }, {});
}

const mapping = Object.values(NAV_CONFIG)
  .map((arr) => flatten(arr))
  .reduce((acc, item) => ({ ...acc, ...item }), {});

export default function Breadcrumbs() {
  const { pathname } = useLocation();
  const shouldHideBreadcrumbs =
    /^\/detail\/[^/]+(?:\/.*)?$/.test(pathname) ||
    /^\/ts\/detail\/[^/]+(?:\/.*)?$/.test(pathname);

  if (shouldHideBreadcrumbs) {
    return null;
  }

  const segments = pathname.split('/').filter(Boolean);
  let acc = '';

  return (
    <nav
      aria-label="breadcrumb"
      className="mx-auto mt-6 w-[92%] max-w-[1380px]"
    >
      <ol className="cms-eyebrow flex flex-wrap items-center gap-2.5 text-[#8c96b3]">
        {segments.length === 0 ? (
          <li className="inline-flex items-center rounded-full border border-[#dfe5f8] bg-white/90 px-3.5 py-1.5 text-[#4a5cff] shadow-[0_6px_14px_rgba(74,92,255,0.06)] transition-all duration-200 hover:-translate-y-0.5 hover:shadow-[0_10px_18px_rgba(74,92,255,0.08)]">
            Dashboard
          </li>
        ) : (
          segments.map((seg, idx) => {
            acc += `/${seg}`;
            const isLast = idx === segments.length - 1;
            const name = mapping[acc] || seg;

            return (
              <React.Fragment key={acc}>
                {idx > 0 && <ChevronRightIcon className="h-3.5 w-3.5 text-[#bcc5df]" />}
                <li
                  className={`inline-flex items-center rounded-full px-3 py-1.5 ${
                    isLast
                      ? 'border border-[#dfe5f8] bg-white text-[#4a5cff] shadow-[0_6px_14px_rgba(74,92,255,0.06)] transition-all duration-200 hover:-translate-y-0.5 hover:shadow-[0_10px_18px_rgba(74,92,255,0.08)]'
                      : 'text-[#8c96b3] transition-colors duration-200 hover:text-[#5d6b8b]'
                  }`}
                >
                  {name}
                </li>
              </React.Fragment>
            );
          })
        )}
      </ol>
    </nav>
  );
}
